import React, { Component } from "react";
import { Table, Button, Row, Col , Input} from "reactstrap";

// UI Components
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";

import Pagination from "react-js-pagination";

import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

import { getBootstrapTableOptions } from "UTILS/Utility";

import ic_edit from "ASSETS/Images/qr_icons/ic_edit.webp";
import ic_delete from "ASSETS/Images/qr_icons/ic_delete.webp";

import { userAction } from "CONFIG/ActionFactory";

import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';

import { PAGE_COUNT, ERROR, modulesAvailableConstant, USER_ROLES } from "UTILS/Constants";

import "../../SuperAdmin/Users/AdminDashboard.less";
import "../../SuperAdmin/Users/ReportComponent/SessionList.less";

export default class UsersList extends Component {

  fetchUsersTableData = (page) => {
    this.props.getAllUserData(
      page - 1,
      this.props.userListPageSize,
      this.props.searchKey ? this.props.searchKey : undefined
    );
    const tableData = document.querySelector(".usersTableContainer .react-bs-container-body");
    tableData.scrollTop = 0;
  }

  renderPageCountOptions = () => {
    return PAGE_COUNT.map(count => {
      return <option value={count} key={"page_" + count}>{count}</option>
    })
  }

  handleChange = user => {
    let data = Object.assign(
      {},
      {
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
        role: user.role,
        username: user.email,
        isAvailable: Number(!user.isAvailable) + "",
        isOperator: user.isOperator,
        operatorSkills: user.operatorSkills,
      }
    );
    this.props.handleSaveClick(data, error => {
      if (error.code !== ERROR.NOT_AUTHORIZED)
        toastr.error(getMessage(error.code));
    })
  }
 
  resetPasswordFormat = (cell, row) => {
    return (
      <Button
        className={row.is_sso_user ? "buttons resetPassword text-center cursorDisabled" : "buttons text-center resetPassword"}
        disabled={row.is_sso_user ? true : false}
        onClick={e => {
          e.stopPropagation();
          this.props.resetPasswordClick(row.id, row.email, row.isID);
        }}
      >
        {getMessage("RESET_PASSWORD")}
      </Button>
    )
  }

  initializeMfaFormat = (cell, row) => {
    return (
      <Button
        className={"buttons resetPassword text-center"}
        onClick={e => {
          e.stopPropagation();
          this.props.initializeMfaClick(row.id, row.email);
        }}
      >
        {getMessage("MFA_RESET_BUTTON")}
      </Button>
    )
  }

  agentAvailableFormat = (cell, row) => {
    return (
      row.role !== USER_ROLES.ADMIN ? 
        (<Switch
          switchOn={row.isAvailable}
          disabled={row.is_sso_user}
          toggleSwitch={() =>{ if(!row.is_sso_user)this.handleChange(row)}}
        />)
        : null
    )
  }

  actionsFormat = (cell, row) => {
    const isEditable =
      !row.is_sso_user ||
      (this.props.modules.includes(modulesAvailableConstant.SUPPORT_CENTER) &&
        row.role === USER_ROLES.AGENT);
    return (
      <div className="justify-content-centre">
        <img
          src={ic_edit}
          className={isEditable ? "pl-4 cursorPointer": "pl-4 cursorDisabled"}
          onClick={() => {if(isEditable)this.props.showEditUserModal(row.id)}}
        />
        {row.id != this.props.loggedUserId &&
        <img
          src={ic_delete}
          className="cursorPointer px-2"
          onClick={e => {
            e.stopPropagation();
            this.props.showDeleteConfirmationModal(
              row.id,
              row.email
            );
          }}
        />}
      </div>
    )
  }

  render() {
    const { userListCurrentPageNo, usersList, usersCount } = this.props;
    const displayPage = userListCurrentPageNo + 1;
    return (
      <div className="usersTableContainer">
        {/* <Table responsive style={{width: "92%"}} className="organisationsList usersList">
          <thead className="tableHeader">
            <tr>
              <th style={{ width: "25%" }}>{getMessage("EMAIL")}</th>
              <th style={{ width: "15%" }}>{getMessage("FIRST_NAME")}</th>
              <th style={{ width: "15%" }}>{getMessage("LAST_NAME")}</th>
              <th style={{ width: "12%" }}>{getMessage("TYPE_OF_USER")}</th>
              <th style={{ width: "10%" }}>
                {getMessage("RESET_PASSWORD_TEXT")}
              </th>
              <th style={{ width: "15%", textAlign: "center" }}>{getMessage("AGENT_AVAILABILITY")}</th>
              <th style={{ width: "8%" }}>{getMessage("ACTIONS")}</th>
            </tr>
          </thead>
          <tbody className="tableBody">
            {_.map(this.props.users, (user, index) => {
              return (
                <tr key={index}>
                  <td maxLength="10" className="invitee nameEllipsis">
                    {user.email}
                  </td>
                  <td className="nameEllipsis">
                    {user.first_name}
                  </td>
                  <td>{user.last_name}</td>
                  <td>{_.capitalize(user.role)}</td>
                  <td>
                    <Button
                      className="buttons resetPassword"
                      onClick={e => {
                        e.stopPropagation();
                        this.props.resetPasswordClick(user.id, user.role);
                      }}
                    >
                      {getMessage("RESET_PASSWORD")}
                    </Button>
                  </td>
                  <td className="alignTextCenter">

                    {user.id != this.props.loggedUserId ? user.isAvailable ? (
                      <img
                        src={ic_switch_on}
                        onClick={() => this.handleChange(user)}
                        className="cursorPointer"
                      />
                    ) : (
                      <img
                        src={ic_switch_off}
                        onClick={() => this.handleChange(user)}
                        className="cursorPointer"
                      />
                    ) : null}
                  </td>
                  <td>
                    <img
                      src={ic_edit}
                      className="mr-3 cursorPointer"
                      onClick={() => this.props.showEditUserModal(user.id)}
                    />
                    {user.id != this.props.loggedUserId &&
                      <img
                        src={ic_delete}
                        className="cursorPointer"
                        onClick={e => {
                          e.stopPropagation();
                          this.props.showDeleteConfirmationModal(
                            user.id,
                            user.role
                          );
                        }}
                      />
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table> */}

        <BootstrapTable 
          data={usersList}
          tableHeaderClass="tableHeader"
          tableBodyClass='tableBody'
          containerClass='organisationsList usersList'
          tableContainerClass=''
          headerContainerClass=''
          bodyContainerClass=''
          bordered={false}
          options={getBootstrapTableOptions()}
          printable
          maxHeight='450px'
        >
          <TableHeaderColumn 
            dataField='email' 
            width="25"
            dataSort={true}
            isKey={true}
            dataFormat={(cell, row) => {
              return (
                <div className="setMargin">
                  <label className="mb-0 nameEllipsis" title={row.email}>
                    {row.email}
                  </label>
                </div>)
            }}>
            {getMessage("ACCOUNT_ID")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='last_name'
            width="13"
            dataSort={true}
            dataFormat={(cell, row) => {
              return (
                <div className="setMargin">
                  <label className="mb-0 nameEllipsis" title={row.last_name}>
                    {row.last_name == null ? "--" : row.last_name}
                  </label>
                </div>)
            }}
            headerAlign="center"
            dataAlign="center"
          >
            {getMessage("LAST_NAME")}
          </TableHeaderColumn>
          <TableHeaderColumn 
            dataField='first_name' 
            dataSort={true}
            width="13"
            className="nameEllipsis"
            dataFormat={(cell, row) => {
              return (
                <div className="setMargin">
                  <label className="mb-0 nameEllipsis" title={row.first_name}>
                    {row.first_name}
                  </label>
                </div>)
            }}
            headerAlign="center"
            dataAlign="center"
          >
            {getMessage("FIRST_NAME")}
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='role'
            width="12"
            dataSort={true}
            dataFormat={(cell, row) => {
              if (this.props.modules.includes(modulesAvailableConstant.SUPPORT_CENTER) && row.isOperator) {
                return (
                  <label className="mb-0" title={getMessage("OPERATOR")}>
                    {getMessage("OPERATOR")}
                  </label>
                )
              } else {
                return (
                  <label className="mb-0" title={getMessage(row.role)}>
                    {getMessage(row.role)}
                  </label>
                )
              }
            }}
            headerAlign="center"
            dataAlign="center"
          >
            {getMessage("TYPE_OF_USER")}
          </TableHeaderColumn>
          <TableHeaderColumn
            width="15"
            dataFormat={this.resetPasswordFormat} 
            headerAlign="center"
            dataAlign="center"
          >
            {getMessage("RESET_PASSWORD_TEXT")}
          </TableHeaderColumn>
          {this.props.modules.includes(modulesAvailableConstant.MFA) &&
          <TableHeaderColumn
            width="15"
            dataFormat={this.initializeMfaFormat} 
            headerAlign="center"
            dataAlign="center"
          >
            {getMessage("MFA_RESET_TITLE")}
          </TableHeaderColumn>}
          {this.props.modules.includes(modulesAvailableConstant.QR_CODE) &&
            <TableHeaderColumn
              dataField='isAvailable'
              width="10"
              dataSort={true}
              dataFormat={this.agentAvailableFormat}
              headerAlign="center"
              dataAlign="center"
            >
              {getMessage("AGENT_AVAILABILITY")}
            </TableHeaderColumn>}
          {this.props.isSSOEnabled ?
            <TableHeaderColumn
              dataField='is_sso_user'
              width="11"
              dataSort={true}
              dataFormat={(cell, row) => {
                return (
                  <div className="setMargin">
                    <label className="mb-0 nameEllipsis" title={row.is_sso_user}>
                      { row.is_sso_user ? getMessage("YES") : getMessage("NO")}
                    </label>
                  </div>)
              }}
              headerAlign="center"
              dataAlign="center"
            >
              {getMessage("IS_SSO_USER")}
            </TableHeaderColumn>
            : null
          }
          <TableHeaderColumn
            width="10"
            dataFormat={this.actionsFormat}
            headerAlign="center"
            dataAlign="center"
          >
            {getMessage("ACTIONS")}
          </TableHeaderColumn>
        </BootstrapTable>

        <div className="usersTabMargin mx-5 px-1 pt-3">
          <Row className="paginationRow"> 
            <Col xs={4} className="paginationEntries">
              {getMessage("PAGINATION_TOTAL_ENTRIES",
                {from:userListCurrentPageNo * this.props.userListPageSize + 1 ,
                  to: userListCurrentPageNo * this.props.userListPageSize + this.props.userListPageSize < usersCount ? userListCurrentPageNo * this.props.userListPageSize + this.props.userListPageSize : usersCount,
                  totalCount: usersCount})}
            </Col> 
            <Col xs={4} className="pagination">
              {usersCount > this.props.userListPageSize ?
                <Pagination
                  activePage={displayPage}
                  itemsCountPerPage={this.props.userListPageSize}
                  totalItemsCount={usersCount}
                  pageRangeDisplayed={3}
                  onChange={this.fetchUsersTableData}
                  itemClass="page-item"
                  linkClass="page-link"
                /> : null
              }
            </Col>
            <Col xs={4} className="pageCount">
              {usersCount > PAGE_COUNT[0] &&
                  <Input type="select" className="inputFormControl selectText form-control border"
                    onChange={(e)=>{
                      userAction.saveUserListPageSize(parseInt(e.target.value))
                      this.props.getAllUserData(0, e.target.value, this.props.searchKey ? this.props.searchKey : undefined);
                    }}
                    value={this.props.userListPageSize}
                  >
                    {this.renderPageCountOptions()}
                  </Input>
              }
            </Col>
          </Row>
        </div>    

      </div>
    );
  }
}
